var _path, _rect, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFk00(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24.45,5.24V1.25c0-.42-.34-.76-.76-.76s-.76.34-.76.76v4.36c0,.27.14.51.37.64,3.3,2.58,5.19,6.45,5.19,10.63,0,3.87-1.65,7.54-4.55,10.1H6.06c-2.89-2.56-4.55-6.23-4.55-10.1,0-4.19,1.89-8.06,5.2-10.64.21-.14.34-.37.34-.63V1.25c0-.42-.34-.76-.76-.76s-.76.34-.76.76v3.99C2.01,8.11,0,12.33,0,16.89s1.93,8.58,5.29,11.43c.09.08.19.12.31.15v.7c0,.19.15.34.34.34h2.25c.19,0,.34-.15.34-.34v-.67h1.05v.67c0,.19.15.34.34.34h2.25c.19,0,.34-.15.34-.34v-.67h1.05v.67c0,.19.15.34.34.34h2.25c.19,0,.34-.15.34-.34v-.67h1.05v.67c0,.19.15.34.34.34h2.25c.19,0,.34-.15.34-.34v-.67h1.05v.67c0,.19.15.34.34.34h2.25c.19,0,.34-.15.34-.34v-.7c.12-.03.23-.07.32-.15,3.36-2.86,5.29-7.02,5.29-11.43s-2.02-8.79-5.55-11.65Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.13,
    y: 3.17,
    width: 3.75,
    height: 14.74,
    rx: 1.13,
    ry: 1.13
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 21.98,
    r: 1.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFk00);
export default __webpack_public_path__ + "static/media/FK00.8347e26ce35702417529b071d36fd6ab.svg";
export { ForwardRef as ReactComponent };